"use client";

import { createGlobalStyle, css } from "styled-components";

export const resetStyles = css`
  @import url("https://fonts.googleapis.com/css2?family=PT+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap");
  @import url("https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100..900;1,100..900&display=swap");
  @import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css");

  :root {
    --font-pt-serif: "PT Serif", serif;
    --font-jost: "Jost", sans-serif;
    --font-poppins: "Poppins", sans-serif;
    --font-pretendard: "Pretendard Variable", Pretendard, -apple-system,
      BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI",
      "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic",
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
  }
  :root {
    --text-weight-regular: 400;
    --text-weight-medium: 500;
    --text-weight-semibold: 600;
    --text-weight-bold: 700;

    --text-weight-extrabold: 600;

    --text-hero-size-lg: 4rem;
    --text-hero-size-md: 3.2rem;
    --text-hero-size-sm: 2.8rem;

    --text-heading-size-xl: 2.4rem;
    --text-heading-size-lg: 2rem;
    --text-heading-size-md: 1.8rem;
    --text-heading-size-sm: 1.6rem;

    --text-body-size-lg: 1.6rem;
    --text-body-size-md: 1.4rem;
    --text-body-size-sm: 1.2rem;
    --text-body-letter-spacing-lg: -0.08px;
    --text-body-letter-spacing-md: -0.07px;
    --text-body-letter-spacing-sm: -0.06px;

    --text-caption-size-lg: 1.1rem;
    --text-caption-size-md: 1rem;
  }

  body {
    background-color: white;
  }
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  html {
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    text-size-adjust: 100%;
  }

  ol,
  ul,
  li {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  button {
    vertical-align: baseline;
    border: 0;
    background: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: "";
    content: none;
  }

  a,
  a:active,
  a:focus,
  a:hover,
  a:link,
  a:visited {
    color: ${({ theme }) => theme?.color?.neural?.gray08 || "inherit"};
    text-decoration: none;
    font-family: inherit;
  }
  a::before {
    content: "";
    position: absolute;
    font-size: 0;
  }
  * {
    font-family: var(--font-pretendard);
    font-style: normal;
    font-weight: 400;
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
  }
  html {
    font-size: 62.5%;
  }
`;

const GlobalStyle = createGlobalStyle`
 ${resetStyles}
	  
`;
export default GlobalStyle;
